// extracted by mini-css-extract-plugin
module.exports = {"title":"Subtitle-module--title--xa4PP"};